export const contactInfo = {
  address: {
    title: 'Visit Us',
    lines: [
      'Pragyavan Wellness Centre',
      'Airport Perimeter Road, Behind Adinatheshwara Temple',
      'Adyapady, Bajpe Proper, Karnataka 574142',
      'India'
    ],
    coordinates: {
      lat: 12.9485,
      lng: 74.8744,
      display: '12.9485° N, 74.8744° E'
    },
    googleMapsLink: 'https://maps.app.goo.gl/HnTXfg3sfV18zcG77'
  },
  
  phone: {
    title: 'Call Us',
    primary: {
      number: '+91 8904568399',
      display: '+91 8904568399',
      type: 'Primary'
    },
    whatsapp: {
      number: '+91 8904568399',
      display: '+91 8904568399',
      type: 'WhatsApp'
    },
    availability: 'Available 9 AM - 7 PM'
  },
  
  email: {
    title: 'Email Us',
    addresses: [
      {
        email: 'pragyavan2017@gmail.com',
        type: 'General Inquiries'
      },
      {
        email: 'pragyavan2017@gmail.com',
        type: 'Bookings & Appointments'
      },
      {
        email: 'pragyavan2017@gmail.com',
        type: 'Information & Support'
      }
    ]
  },
  
  hours: {
    title: 'Operating Hours',
    schedule: [
      {
        days: 'Monday - Sunday',
        hours: '6:00 AM - 8:00 PM',
        type: 'Center Operations'
      },
      {
        days: 'Monday - Saturday',
        hours: '9:00 AM - 6:00 PM',
        type: 'Reception Desk'
      },
      {
        days: '24/7',
        hours: 'Always Available',
        type: 'WhatsApp Support'
      }
    ]
  },
  
  transportation: {
    byCar: [
      'Free parking available on-site',
      '2 minutes from Airport Road',
      'Easy highway access from city center',
      'GPS coordinates: 12.9485° N, 74.8744° E'
    ],
    byTrain: [
      'Mangalore Central Railway Station - 12 km',
      'Mangalore Junction - 14 km',
      'Taxi/auto available from stations',
      'Pre-arranged pickup service available'
    ],
    byBus: [
      'Airport bus stop - 500 meters',
      'City bus routes 2A, 15, 23 available',
      'Private bus services to major cities',
      'Walking distance from bus stop'
    ],
    byAir: [
      'Mangalore International Airport - 3 km',
      'Taxi services available 24/7',
      'Pre-book airport pickup',
      'Direct connectivity to major Indian cities'
    ]
  }
};

export const emergencyContact = {
  title: 'Emergency Contact',
  number: '+91 8904568399',
  available: '24/7 for emergencies only',
  note: 'For urgent matters related to your wellness sessions'
};